import { REVIEW_FEATURES } from './constants';
import type { ReviewFeaturesT } from './types';
export const DEFAULT_REVIEW_FEATURE_CONFIG: ReviewFeaturesT = {
  [REVIEW_FEATURES.ACCEPT_REJECT_TASK]: false,
  [REVIEW_FEATURES.ACCEPT_REJECT_LABEL]: false,
  [REVIEW_FEATURES.ENABLE_COMMENTS_FEEDBACK]: false,
  [REVIEW_FEATURES.ENABLE_MISSING_LABELS_FEEDBACK]: false,
  [REVIEW_FEATURES.CAN_EDIT]: false,
  [REVIEW_FEATURES.ENABLE_CONTINUOUS_PLAYBACK]: false,
  [REVIEW_FEATURES.ENABLE_BATCH_MODE]: false
};